document.addEventListener("DOMContentLoaded", function(event) {
  const btn = document.querySelector("#nav-btn");
  const menu = document.querySelector("#mobile-nav");
  const hamburger = document.querySelector("#hamburger");
  btn.addEventListener(
    "click",
    function() {
      hamburger.classList.toggle("is-active");
      menu.classList.toggle("hidden");
    },
    false
  );
});
